/**
 * stacktraceNS のエントリポイント (en)。
 *
 * defaultNS の ParseKeys 肥大化による tsgo TS2859 を回避するため、
 * stacktrace 系機能の翻訳キーは defaultNS から切り出してこの namespace で管理する。
 */
import { pagesCustomersEn } from './stacktrace/customers/customers';
import { pagesDevDocumentsEn } from './stacktrace/dev-documents/dev-documents';
import { pagesIncidentsEn } from './stacktrace/incidents/incidents';
import { pagesIssuesEn } from './stacktrace/issues/issues';
import { pagesPlanningOperationsCoreEn } from './stacktrace/planning-operations-core/planning-operations-core';
import { pagesProductPlanningCoreEn } from './stacktrace/product-planning-core/product-planning-core';
import { pagesProductRoadmapEn } from './stacktrace/product-roadmap/product-roadmap';
import { pagesProductionEn } from './stacktrace/production/production';
import { pagesProductsEn } from './stacktrace/products/products';
import { pagesQaOperationsCoreEn } from './stacktrace/qa-operations-core/qa-operations-core';
import { pagesTestAssetsEn } from './stacktrace/test-assets/test-assets';
import { pagesTestSetsEn } from './stacktrace/test-sets/test-sets';
import { pagesTestSuitesEn } from './stacktrace/test-suites/test-suites';
import { pagesTicketsEn } from './stacktrace/tickets/tickets';
import { pagesValuesEn } from './stacktrace/values/values';
const stacktraceEn = {
  customers: pagesCustomersEn,
  devDocuments: pagesDevDocumentsEn,
  incidents: pagesIncidentsEn,
  issues: pagesIssuesEn,
  planningOperationsCore: pagesPlanningOperationsCoreEn,
  productPlanningCore: pagesProductPlanningCoreEn,
  productRoadmap: pagesProductRoadmapEn,
  production: pagesProductionEn,
  products: pagesProductsEn,
  qaOperationsCore: pagesQaOperationsCoreEn,
  testAssets: pagesTestAssetsEn,
  testSets: pagesTestSetsEn,
  testSuites: pagesTestSuitesEn,
  tickets: pagesTicketsEn,
  values: pagesValuesEn
} as const;
export default stacktraceEn;